<template>
<div>
    <div class="card-grid-item" style="cursor: default;" v-if="!loading">
        <div class="panel mar-no">
            <div class="panel-heading">
                <h2 class="panel-title library-card-panel-title"><i class="text-center fa fa-university"></i> <span>BENI ARCHEOLOGICI</span></h2>
            </div>
            <div class="panel-body">
                <div class="row" v-for="(report,k) in reports" :key="k" :report="report">
                    <div class="col-xs-1 col-sm-1 col-md-1"><i class="fa fa-circle pull-left"></i></div>
                    <div class="col-xs-7 col-sm-6 col-md-6"><span class="pull-left">  {{report["Nome"]}}</span></div>
                    <div class="col-xs-3 col-sm-4 col-md-4"><span class="pull-left">  {{report["Archeological area"]}}</span></div>
                    <div class="col-xs-1 col-sm-1 col-md-1"><a style="cursor: pointer" @click="heritageSelected(k)"><i class="fa fa-arrow-circle-right"></i></a></div>
                    <!-- <div class="col-xs-1 col-sm-1 col-md-1"><a @click="heritageToModifySelected(k)"><i class="ion-edit"></i></a></div> -->
                    <hr/>
                </div>
                
            </div>
            <div class="panel-footer">
                <div class="row">
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <a   v-bind:class="[ 'btn', 'btn-primary', 'btn-labeled', 'fa', 'fa-plus', 'pull-left']" role="button" @click="goAdd()">
                            AGGIUNGI</a>
                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <a  v-bind:class="['btn', 'btn-primary', 'btn-labeled', 'fa', 'fa-search', 'pull-right']" role="button" @click="goSearch()">
                                CERCA</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-grid-item report-modal" v-else>
         <div class="block">
            <p class="circle">
                <span class="ouro ouro3">
                    <span class="left"><span class="anim"></span></span>
                    <span class="right"><span class="anim"></span></span>
                </span>
            </p>
         </div>
    </div>
</div>
</template>
<script>

import axios from 'axios';

export default {
    name: 'HeritagePanel',
    props: {
        api: null,
        config: null
    },
    data: function () {
        return {
            reports: {type: Array, value: []},
            loading: false

        }
    },
    methods: {
        search: function() {
            this.load(true);
            this.api.findHeritages().then(axios.spread((...responses) => {
                let out_data_temp = [];
                let resourse_ids = [];
                for (let response of responses) {
                    let array = [];
                    for (let i=0; i<response.data['tiles'].length; i++) {
                        let item = response.data['tiles'][i]
                        if('display_values' in item) {
                            array = array.concat(item['display_values']);
                        }
                    }
                    out_data_temp.push(array);
                    resourse_ids.push(response.data['tiles'][0]['resourceinstance']);
                }
                let display_data = {};
                for (let i=0; i<out_data_temp.length; i++)  {
                    let obj_json = {}
                    for (let obj of out_data_temp[i]) {
                        obj_json[obj['label']] = obj['value']
                        }
                    display_data[resourse_ids[i]] = obj_json;
                }

                this.reports = display_data;
                this.load(false);
            },
            (error) => {
                console.log(error);
                this.load(false);
            }
            ));
        },
        heritageSelected: function(value) {
            console.log(value);
            let report_id = value;
            window.open(`/resource/${report_id}`,'_blank');
        },
        goAdd: function() {
            window.open(`/add-resource/${this.config.archaeological_heritage_graph_id}`,'_blank');
        },
        goSearch: function() {
            window.open(`/search?typeFilter=[{"graphid":"99417385-b8fa-11e6-84a5-026d961c88e6","name":"Bene archeologico","inverted":false}]&no_filters=false&page=1`,'_blank');
        },
        load(value) {
            this.loading = value;
        }
    },
    created: function() {
        this.search();
    }
}
</script>

<style scoped>
    .card-grid-item {
        width: 100%;
        text-overflow: ellipsis;
        word-wrap: break-word;
        padding-bottom: 0px;
        min-width: 340px;
   }
    .car-grid-item * {
        display: block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .panel-body {
        min-height: 251px;
    }

   .addScroll{
    overflow-y:auto;
    height: 200px;
    }

    .card-grid-item.report-modal {
        min-height: 355px;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        text-align:center;
        display:table; 
        width:500px;

    }

    #app .block {
        display: table-cell; 
        vertical-align:middle
    }

    @media only screen and (max-device-width: 480px) {
    
        .card-grid-item {
            width: unset;
            min-width: 320px;
        }
    
        .card-grid-item.report-modal {

            min-width: 320px;
            width: unset;

            }
        
        #app > div > div.content-panel > div > div {
            flex-direction: column;
        }

    }
</style>

